import { memo } from 'react';
import NextLink from 'next/link';
import { Text, VStack, Link, UnorderedList, ListItem } from '@chakra-ui/react';

import NextImage from 'shared/NextImage';
import ContentParser from './ContentParser';

const TechExpertCard = ({
  title,
  titleProps = null,
  content,
  contentProps = null,
  description = null,
  descriptionIcon = null,
  link = null,
  subTitle = null,
}) => (
  <VStack w="full" h="full" p={{ mobile: '24px', laptop: '48px' }}>
    <VStack
      w="full"
      align="start"
      gap={{ laptop: '24px', mobile: '12px' }}
      flex="1 1 auto"
      {...contentProps}
    >
      {title && (
        <Text as="h3" {...titleProps}>
          {title}
        </Text>
      )}

      {subTitle && <Text as="h4">{subTitle}</Text>}

      <ContentParser content={content} />

      {description && (
        <VStack
          w="full"
          align="start"
          gap={{ laptop: '24px', mobile: '12px' }}
          textStyle="h4"
          fontSize={{ mobile: '12px', laptop: '16px', desktop: '18px' }}
        >
          <Text>{description?.title}</Text>

          <UnorderedList ml={{ mobile: '26px', laptop: '30px', desktop: '32px' }}>
            {description?.list.map((text, i) => (
              <ListItem key={`text-${i}`}>{text}</ListItem>
            ))}
          </UnorderedList>
        </VStack>
      )}

      {link && (
        <Link
          as={NextLink}
          href={link}
          isExternal
          textStyle="button.secondary"
          textDecoration="underline"
          textUnderlineOffset="0.25em"
        >
          Подробнее
        </Link>
      )}
    </VStack>

    {descriptionIcon && (
      <NextImage
        src={descriptionIcon}
        alt="Иллюстрация карточки"
        w="auto"
        h={{ laptop: '330px', mobile: '160px' }}
        objectFit="contain"
      />
    )}
  </VStack>
);

export default memo(TechExpertCard);
